<template>
  <div class="p-3 border-t border-gray-200">
    <div class="flex items-center" :class="{ 'justify-center': collapsed }">
      <!-- Avatar -->
      <div class="h-8 w-8 rounded-full overflow-hidden bg-indigo-600 flex items-center justify-center">
        <img v-if="userAvatar" :src="userAvatar" alt="Avatar" class="h-8 w-8 object-cover" />
        <span v-else class="text-sm font-medium text-white">{{ getInitials(userName) }}</span>
      </div>
      <div v-if="!collapsed" class="ml-3 flex-1 transition-opacity duration-300">
        <div class="text-sm font-medium text-gray-700">{{ userName }}</div>
        <div class="text-xs text-gray-500">{{ userRole }}</div>
      </div>
      <button 
        v-if="!collapsed"
        @click="$emit('logout')" 
        class="ml-2 text-red-500 hover:text-red-700 transition-opacity duration-200"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  collapsed: boolean
  userName: string
  userRole: string
  userAvatar: string
}

defineProps<Props>()

defineEmits<{
  logout: []
}>()

const getInitials = (name: string) => {
  return name.split(' ').map(n => n[0]).join('')
}
</script>
